/**
 * @file Saved-lists DTOs — P21 C2 (CRUD) + C3 (add-to-cart).
 *
 * Returned by `GET /v1/storefront/me/saved-lists` (list) and
 * `GET /v1/storefront/me/saved-lists/:id` (detail).
 * `POST /v1/storefront/me/saved-lists/:id/add-to-cart` returns
 * `SavedListAddToCartResponse`.
 */
import { z } from "zod";
import { uuidLoose } from "./uuid.js";
export const CreateSavedListBody = z.object({ name: z.string().min(1).max(120) });
export const SavedListItemBody = z.object({
    // `uuidLoose` (not strict `z.uuid()`): zod v4's `.uuid()` enforces RFC 9562
    // version/variant nibbles, which rejects the deterministic seed UUIDs
    // (e.g. `00000000-0000-0000-0000-b000000000NN`) that real prod variants
    // carry. cart-bodies + checkout already use uuidLoose for exactly this; the
    // saved-lists body was missed, so add-to-list 400'd on seeded variants.
    variant_id: uuidLoose,
    quantity: z.number().int().positive(),
});
